import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "flowbite-react";
import { MdWarningAmber } from "react-icons/md";

const ModalEditPrice = ({
  isOpen,
  onClose,
  onSave,
  initialPrice,
  title = "Editar preço",
  description = "Esta é uma alteração sensível. Modificar o preço impactará diretamente nos relatórios e faturamento.",
}) => {
  const [price, setPrice] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setPrice(initialPrice ? parseFloat(initialPrice).toFixed(2) : "");
  }, [initialPrice]);

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const handleChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    if (!raw) return setPrice("");
    const parsed = parseFloat(raw) / 100;
    setPrice(parsed.toFixed(2));
  };

  const handleSubmit = async () => {
    const parsedPrice = parseFloat(price);
    if (isNaN(parsedPrice)) return;

    try {
      setIsSubmitting(true);
      await onSave(parsedPrice);
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      // opcional: alert ou toast
    }
  };

  return (
    <Modal show={isOpen} size="sm" onClose={onClose} popup>
      <ModalHeader />
      <ModalBody>
        <div>
          <div className="flex items-center gap-2 justify-center text-yellow-600 mb-2">
            <MdWarningAmber className="text-xl" />
            <h2 className="text-lg font-semibold">{title}</h2>
          </div>
          <p className="text-sm text-center text-yellow-600 font-medium mb-4">
            {description}
          </p>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Novo Preço
            </label>
            <input
              type="text"
              value={price ? formatCurrency(price) : ""}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md p-2 text-sm"
            />
          </div>
        </div>
        <div className="flex justify-center gap-2">
          <Button
            className="px-3"
            onClick={handleSubmit}
            isProcessing={isSubmitting}
          >
            {isSubmitting ? "Salvando..." : "Salvar"}
          </Button>
          <Button color="gray" onClick={onClose} isProcessing={isSubmitting}>
            Cancelar
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalEditPrice;
